import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { AgentOrangePostCardStackBackgroundViewModel } from './agent-orange-post-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-agent-orange-post-card-stack-background',
  templateUrl: './agent-orange-post-card-stack-background.component.html',
  styleUrls: ['./agent-orange-post-card-stack-background.component.scss'],
  providers: [AgentOrangePostCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AgentOrangePostCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: AgentOrangePostCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
